module.exports = __webpack_public_path__ + "img/smiley.28ff52a8.svg";